// Load default Webentor JS features
import './_header';

import Gallery from './_gallery';
import Lightbox from './_lightbox';

// Register Alpine last to ensure all extensions are registered
import './_alpine';

// Register static assets
import.meta.glob(['../images/**', '../fonts/**'], {
  eager: true,
  query: '?url',
  import: 'default',
});

new Lightbox();
// `selector: 'a'` (not the immediate-children default): the desktop collage
// nests its tiles inside two row wrappers, so the anchors are descendants, not
// direct children. This finds every tile <a> in DOM order across both rows.
new Lightbox('.lightgallery-gallery', {
  selector: 'a',
});

// Galleries whose slide list is a markup stub with no visible tiles — §11 plan
// cards, where a hidden <a> per photo sits behind a button on the card image.
//
// `thumbnail: false` is the point of this instance. lightGallery builds the
// thumbnail strip during init, not on open, so every bound gallery downloads one
// image per slide on page load (§6 pays this today with FULL-SIZE originals).
// A gallery nobody has opened yet shouldn't cost anything, and a handful of
// photos navigates fine with arrows + the counter. Dropping the strip also means
// the stub anchors need no inner <img> — which the browser would fetch even
// inside a display:none wrapper, `loading="lazy"` included.
//
// Separate container class on purpose: turning the strip off on
// `.lightgallery-gallery` would take it away from §6, where it earns its keep.
new Lightbox('.lightgallery-stub-items', {
  selector: 'a',
  thumbnail: false,
});

// §6 media-gallery: arrow scrolling + mobile "Zobraziť viac" → lightbox.
new Gallery();
